<template>
    <div class="investigative-action">
        <Row class="detail-header">
            <span>侦查行动</span>
            <Button class="add-btn" v-if="infoCtrl&&isDetailLoad&&defaultData.turnType==''" type="primary" @click="getDetail('edit')">修改</Button>
        </Row>
        <Row class="case-content">
            <Row v-if="!infoCtrl&&isDetailLoad">
                <Form ref="formData" class="case-form" :model="formData" :rules="ruleValidate" :label-width="100">
                    <FormItem label="行动时间" prop="investigateDate">
                        <DatePicker 
                                transfer 
                                type="date" 
                                placeholder="请选择行动时间" 
                                style="width:100%" 
                                format="yyyy-MM-dd" 
                                :value="formData.investigateDate"
                                @on-change="getTime"></DatePicker>
                    </FormItem>
                    <FormItem label="结果" prop="results">
                        <Input v-model="formData.results" type="textarea" :autosize="{minRows: 3,maxRows: 10}" placeholder="请输入查处产品/查扣数量/案值"></Input>
                    </FormItem>
                    <FormItem label="查处主体" prop="subject">
                        <Input v-model="formData.subject" placeholder="请输入查处主体"></Input>
                    </FormItem>
                    <FormItem label="查处当事人" prop="litigant">
                        <Input v-model="formData.litigant" placeholder="请输入查处当事人"></Input>
                    </FormItem>
                    <FormItem label="查处地址" prop="address">
                        <Input v-model="formData.address" placeholder="请输入查处地址"></Input>
                    </FormItem>
                    <FormItem label="执法部门" prop="lawEnforcement">
                        <Input v-model="formData.lawEnforcement" placeholder="请输入执法部门"></Input>
                    </FormItem>
                    <FormItem label="执法联系人" prop="lawEnforcementContact">
                        <Input v-model="formData.lawEnforcementContact" placeholder="请输入执法联系人"></Input>
                    </FormItem>
                    <FormItem label="执法地址" prop="lawEnforcementAddress">
                        <Input v-model="formData.lawEnforcementAddress" placeholder="请输入执法地址"></Input>
                    </FormItem>
                    <FormItem label="是否转换案件类型" prop="turnType">
                        <RadioGroup v-model="formData.turnType">
                            <Radio label="CL" :disabled="defaultData.turnType==''">转民事</Radio>
                            <Radio label="CC" :disabled="defaultData.turnType==''">转刑事</Radio>
                            <Radio label="AC" :disabled="defaultData.turnType==''">不转</Radio>
                        </RadioGroup>
                        <Row class="notice" v-if="formData.turnType!=='AC'">转{{formData.turnType=='CL'?'民事':'刑事'}}案件后，将终止当前案件，并新建{{formData.turnType=='CL'?'民事':'刑事'}}案件！</Row>
                    </FormItem>
                    <FormItem label="转案原因" prop="stopRemark" v-if="formData.turnType!=='AC'"
                        :rules="[{ required: true, message: '转案原因不能为空', trigger: 'blur' },{ max:200,message:'不能超过200个字符',trigger:'blur' }]">
                        <Input v-model="formData.stopRemark" type="textarea" placeholder="请填写转案原因"></Input>
                    </FormItem>
                    <FormItem label="行动文件" prop="attachmentList">
                        <file-upload
                                :defaultList="defaultList || []" 
                                :uploadConfig="{}"
                                @getFileList="getAttachmentList"></file-upload>
                    </FormItem>
                </Form>
                <Row class="detail-btn-box">
                    <Button type="primary" style="margin-right:10px;" :disabled="isSubmit" @click="submitNew()">保存</Button>
                    <Button v-if="defaultData" @click="infoCtrl=true">取消</Button>
                </Row>
            </Row>
            <Row class="detail-content" v-if="infoCtrl&&isDetailLoad">
                <Row><Col span="5" class="left-label">行动时间：</Col><Col span="16" class="right-content">{{defaultData.investigateDate}}</Col></Row>
                <Row><Col span="5" class="left-label">结果：</Col><Col span="16" class="right-content">{{defaultData.results}}</Col></Row>
                <Row><Col span="5" class="left-label">查处主体：</Col><Col span="16" class="right-content">{{defaultData.subject}}</Col></Row>
                <Row><Col span="5" class="left-label">查处当事人：</Col><Col span="16" class="right-content">{{defaultData.litigant}}</Col></Row>
                <Row><Col span="5" class="left-label">查处地址：</Col><Col span="16" class="right-content">{{defaultData.address}}</Col></Row>
                <Row><Col span="5" class="left-label">执法部门：</Col><Col span="16" class="right-content">{{defaultData.lawEnforcement}}</Col></Row>
                <Row><Col span="5" class="left-label">执法联系人：</Col><Col span="16" class="right-content">{{defaultData.lawEnforcementContact}}</Col></Row>
                <Row><Col span="5" class="left-label">执法地址：</Col><Col span="16" class="right-content">{{defaultData.lawEnforcementAddress}}</Col></Row>
                <Row v-if="!defaultData.turnType"><Col span="5" class="left-label">是否转换案件类型：</Col><Col span="16" class="right-content">未转</Col></Row>
                <Row v-if="defaultData.turnType">
                    <Col span="5" class="left-label">是否转换案件类型：</Col>
                    <Col span="16" class="right-content notice">已转成编号为&nbsp; <strong>{{defaultData.caseCode}}</strong> &nbsp;的{{defaultData.turnType=='CL'?'民事':'刑事'}}案件</Col>
                </Row>
                <Row v-if="defaultData.turnType"><Col span="5" class="left-label">转案原因：</Col><Col span="16" class="right-content">{{defaultData.stopRemark}}</Col></Row>
                <Row>
                    <Col span="5" class="left-label">行动文件：</Col>
                    <Col span="16" class="right-content">
                        <file-upload
                            :defaultList="defaultData.attachmentList || []" 
                            :uploadConfig="{readOnly:true}"></file-upload>
                    </Col>
                </Row>
            </Row>
        </Row>

        <!-- 提示 -->
        <Modal
            v-model="turnTypeCtrl"
            title="转案确认"
            :width="360"
            :footer-hide="true">
            <Row class="modal-tips">提交后不可更改，是否确认提交？</Row>
            <Row style="text-align:center;margin:10px 0px 14px;">
                <Button type="primary" :disabled="isSubmit" @click="submitNew('reSubmit')">确定</Button>
                <Button @click="turnTypeCtrl=false" style="margin-left: 8px">取消</Button>
            </Row>
        </Modal>
    </div>
</template>
<script>
export default {
    data () {
        return {
            editId:'',
            isDetailLoad:false,
            infoCtrl:true,
            isSubmit:false,
            defaultData:"",
            defaultList:[],
            turnTypeCtrl:false,
            formData:{
                investigateDate:"",
                results:"",
                subject:"",
                litigant:"",
                address:"",
                lawEnforcement:"",
                lawEnforcementContact:"",
                lawEnforcementAddress:"",
                attachmentList:[],
                turnType:"AC",
                stopRemark:''
            },
            ruleValidate:{
                investigateDate:[{ required: true, message: '行动时间不能为空', trigger: 'blur' }],
                results:[{ required: true, message: '结果不能为空', trigger: 'blur' },{ max:1024,message:'不能超过1024个字符',trigger:'blur' }],
                subject:[{ required: true, message: '查处主体不能为空', trigger: 'blur' },{ max:128,message:'不能超过128个字符',trigger:'blur' }],
                litigant:[{ required: true, message: '查处当事人不能为空', trigger: 'blur' },{ max:128,message:'不能超过128个字符',trigger:'blur' }],
                address:[{ required: true, message: '查处地址不能为空', trigger: 'blur' },{ max:256,message:'不能超过256个字符',trigger:'blur' }],
                lawEnforcement:[{ required: true, message: '执法部门不能为空', trigger: 'blur' },{ max:64,message:'不能超过64个字符',trigger:'blur' }],
                lawEnforcementContact:[{ required: true, message: '执法联系人不能为空', trigger: 'blur' },{ max:32,message:'不能超过32个字符',trigger:'blur' }],
                lawEnforcementAddress:[{ required: true, message: '执法地址不能为空', trigger: 'blur' },{ max:256,message:'不能超过256个字符',trigger:'blur' }],
                attachmentList:[{ required: true,type:"array", message: '行动文件不能为空', trigger: 'blur' }],
                turnType:[{ required: true,message: '是否转案件类型不能为空', trigger: 'blur' }],
            }
        }
    },
    props: ['processId','caseId'],
    methods: {
        getTime(value){
            this.formData.investigateDate = value;
        },
        getAttachmentList(arr){
            this.formData.attachmentList = [];
            arr.forEach((item,index)=>{
                let obj = {
                    fileName:item.fileName,
                    mediaType:item.mediaType,
                    smallUrl:item.smallUrl,
                    url:item.url
                }
                this.formData.attachmentList.push(obj);
            })
        },
        submitNew(type){
            console.log(this.formData.turnType);
            let url = "/business/case/administrative/investigation";
            let ajaxData = {
                processId:this.processId,
                caseId:this.caseId
            }
            Object.assign(ajaxData,this.formData);
            ajaxData.turnType = ajaxData.turnType=='AC'?'':ajaxData.turnType;
            ajaxData.stopRemark = ajaxData.turnType=='AC'?'':ajaxData.stopRemark;
            this.$refs['formData'].validate((valid) => {
                if(valid){
                    if(this.formData.turnType=='AC'||type=='reSubmit'){
                        this.continueSubmit(ajaxData,url);
                    }else if(this.formData.turnType=="CL" || this.formData.turnType=="CC"){
                        this.turnTypeCtrl = true;
                    }
                }
            })
        },
        // 继续提交
        continueSubmit(ajaxData,url){
            this.isSubmit = true;
            if(this.defaultData){
                ajaxData.id = this.editId;
                this.$patch(url,ajaxData).then(res=>{
                    this.isSubmit = false;
                    if(res.code==0){
                        this.getDetail();
                        this.$Message.success("操作成功");
                        this.$emit('reloadProcess');
                    }else{
                        this.$Message.error(res.message);
                    }
                })
            }else{
                this.$post(url,ajaxData).then(res=>{
                    this.isSubmit = false;
                    if(res.code==0){
                        this.getDetail();
                        this.$Message.success("操作成功");
                        this.$emit('reloadProcess');
                    }else{
                        this.$Message.error(res.message);
                    }
                })
            }
        },
        getDetail(type){
            let url = '/business/case/administrative/investigation/'+this.processId;
            this.$get(url).then(res=>{
                if(res.code===0&&res.data){
                    this.defaultData = res.data;
                    this.infoCtrl = type=='edit'?false:true;
                    if(type==='edit'){
                        this.giveDefaultData(res.data)
                    }
                    this.isDetailLoad = true;
                }else{
                    this.isDetailLoad = true;
                    this.infoCtrl = false;
                }
            })
        },
        giveDefaultData(value){
            let data = JSON.parse(JSON.stringify(value))
            this.editId = data.id;
            for(let key in this.formData){
                this.formData[key] = data[key];
            }
            this.formData.turnType = data.turnType==''?'AC':data.turnType;

            this.formData.attachmentList = [];
            this.defaultList = [];
            data.attachmentList.forEach((attItem)=>{
                let obj = {
                    fileName:attItem.fileName,
                    mediaType:attItem.mediaType,
                    smallUrl:attItem.smallUrl,
                    url:attItem.url
                }
                this.formData.attachmentList.push(obj);
                this.defaultList.push(obj);
            })
        }
    },
    created(){},
    beforeMount(){

    },
    mounted(){
        this.getDetail();
    },
    updated(){},
    components: {},
    watch: {}
}
</script>
<style lang="scss" scoped>
@import '@/assets/globalStyle.scss';
@import '../../civilCase/caseCommon.scss';
.investigative-action{
    .case-content{
        .notice{
            color:$errorColor;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/administrativeCase/investigativeAction/index.vue